import { CoreApi, HelpLinesBoxColliderComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';

const shouldWarnAboutFramesOutsideOfHelpLines = (coreApi: CoreApi): boolean => {
  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  let warningsFound = false;

  const validations = coreApi.getServices().validations;
  frames.forEach(frame => {
    const validationResult = validations.validateCurrentState(frame, false);
    validationResult.forEach((result: any) => {
      if (result.otherEntity?.hasComponent(HelpLinesBoxColliderComponent.id)) {
        warningsFound = true;
      }
    });
  });
  return warningsFound;
};

export default shouldWarnAboutFramesOutsideOfHelpLines;
